import { FormikProvider, useFormik } from 'formik';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { Flex } from 'reflexbox';

import * as graphql from '@treams/treams-network';

import FilledInBy from './common/FilledInBy';
import Paragraph from './common/Paragraph';

export default function ParagraphModal(props: {
	fillInBy: graphql.EvaluationFillInBy;
	item: graphql.EvaluationParagraphItem;
	onChange: (
		item: graphql.EvaluationParagraphItem | undefined,
		fillInBy: graphql.EvaluationFillInBy,
	) => void;
}) {
	const { t } = useTranslation();

	const formik = useFormik({
		initialValues: {
			text: props.item.text,
			fillInBy: props.fillInBy,
		},
		onSubmit: () => {},
	});

	useEffect(() => {
		if (
			!formik.values.text.some(
				({ text }) => text.ops.map((op) => op.insert ?? '').join('').length > 0,
			)
		) {
			props.onChange(undefined, formik.values.fillInBy);

			return;
		}

		props.onChange(
			{
				...props.item,
				text: formik.values.text.map((text) => ({
					languageID: text.languageID,
					text: text.text,
				})) as graphql.LocalizedAttributedString,
			},
			formik.values.fillInBy,
		);
	}, [formik.values.text, formik.values.fillInBy]);

	return (
		<FormikProvider value={formik}>
			<Flex p={3} flexDirection="column">
				<Paragraph label={t('common.settings.evaluationForms.properties.text.title')} name="text" />
				<FilledInBy />
			</Flex>
		</FormikProvider>
	);
}
